import { mapState } from 'vuex';
import lakuPandaiDigitalSendTracker from 'shared_js/modules/tracker/lakuPandaiDigitalSendTracker';

export default {
  computed: {
    ...mapState('transaction', {
      transactionId: state => state.transactionId,
      productTransactionType: state => state.type,
    }),
    ...mapState('user', ['sendMoneyUserInfo']),
    tracker() {
      switch (this.productTransactionType) {
        case 'digital-send':
          return lakuPandaiDigitalSendTracker;
        case 'digital-send-allobank':
          // TO DO, change to correct tracker later
          return lakuPandaiDigitalSendTracker;
        /* istanbul ignore next */
        default:
          return null;
      }
    },
  },
  methods: {
    actionTrack(screenName, action, timestamp = null, additionalPayload = {}) {
      const trackerParams = {
        transaction_id: this.transactionId.toString(),
        kyc_status: this.sendMoneyUserInfo.status,
        bl_username:
          this.sendMoneyUserInfo.username ||
          (window.USER && window.USER.username) ||
          '',
      };

      if (this.tracker === null) return;

      this.tracker.trackActionDigitalTrx(
        screenName,
        action,
        {
          ...trackerParams,
          ...additionalPayload,
        },
        this.productTransactionType,
        timestamp,
      );
    },
    actionTrackBraze(actionName) {
      const transactionTypeStandardize = this.productTransactionType.replace(
        '-',
        '_',
      );
      window.externalTracker.tracker.braze.event.custom(
        `${transactionTypeStandardize}_${actionName}`,
        {},
      );
    },
    updateSource(customSource) {
      if (this.tracker === null) return;
      this.tracker.updateSource(customSource);
    },
    updateReferrer(customReferrer = null) {
      if (this.tracker === null) return;
      this.tracker.updateReferrer(customReferrer);
    },
    setAppJourneyID(appJourneyID) {
      if (this.tracker === null) return;
      this.tracker.setAppJourneyID(appJourneyID);
    },
    setSourceType(sourceType) {
      if (this.tracker === null) return;
      this.tracker.setSourceType(sourceType);
    },
    setChannelType(channelType) {
      if (this.tracker === null) return;
      this.tracker.setChannelType(channelType);
    },
    setSubchannel(subchannel) {
      if (this.tracker === null) return;
      this.tracker.setSubchannel(subchannel);
    },
    setCampaignName(campaignName) {
      if (this.tracker === null) return;
      this.tracker.setCampaignName(campaignName);
    },
    setMedia(media) {
      if (this.tracker === null) return;
      this.tracker.setMedia(media);
    },
    setDopeKey(dopeKey) {
      if (this.tracker === null) return;
      this.tracker.setDopeKey(dopeKey);
    },
  },
};
